/* * 书签面板 * @module view/bookMarkManage/bookMarkManage * @desc 用于书签管理 * @author sunsi *
@date 2020年12月3日 */
<template>
  <div style="font-size: 12px">
    <Row type="flex" justify="end" style="display: flex; font-size: 20px; margin:-8px -11px 5px 30px">
      <Button size="small" style="margin-left:10px" @click="addBookMark" type="primary" shape="circle" icon="md-add">
      </Button>
      <!-- <div class="icon" @click="addBookMark">
        <Icon type="md-add-circle" style="color: #0099fa" />
      </div> -->
      <Button size="small" style="margin-left:10px" @click="delBookmark" type="primary" shape="circle" icon="md-trash">
      </Button>
    </Row>
    <Row v-if="data.length == 0" style="text-align: center; margin-top: 70px">
      <img src="../../../static/image/no-data.png" />
    </Row>
    <Row
      v-if="data.length > 0"
      type="flex"
      justify="center"
      style="position: absolute;"
    >
       <List item-layout="vertical">
      <ListItem v-for="(item, index) in data" :key="item.title">
        <div @click="setPostion(item, index)">
          <ListItemMeta :title="index + 1 + '.' + item.title+'——日期:'+item.createTime" />
          <img
            :src="xbootConfig+'/file/view/' + item.fileId"
            :class="position === index ? 'active' : 'noActive'"
            style="width: 280px; height: 127px"
          />
          <!-- :class="{ active: position === index }" -->
        </div>
      </ListItem>
    </List>
      <Page
        :current="searchForm.pageNumber"
        :total="total"
        :page-size="searchForm.pageSize"
        @on-change="changePage"
        :page-size-opts="[10, 20, 50]"
        size="small"
        show-total
        show-elevator
      ></Page>

       <Spin size="large" fix v-if="bookspinShow"></Spin>
    </Row>
    <Modal
      id="addBook"
      title="添加书签"
      v-model="addBookModal"
      :mask-closable="false"
      :mask="false"
      :width="330"
    >
      <Form ref="addForm" :model="addForm" inline :label-width="50" style="margin-top: 10px;">
        <FormItem label="名称" prop="title">
          <Input type="text" style="width: 227px" v-model="addForm.title" placeholder="新标签页">
          </Input>
        </FormItem>
        <!-- <Row type="flex" justify="end">
          <FormItem>
            <Button type="primary" @click="saveAs">保存</Button>
          </FormItem>
        </Row> -->
      </Form>
      <div slot="footer">
            <!-- <Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button> -->
            <Button type="primary" :loading="add_loading" @click="saveAs">保存</Button>
        </div>
    </Modal>
  </div>
</template>
<script>
import bookMarkManage from './bookMarkManage';
export default bookMarkManage;
</script>
<style lang="less" scoped>
/deep/.ivu-list-vertical .ivu-list-item-meta {
  margin-bottom: 0 !important;
}
/deep/.ivu-list-vertical .ivu-list-item-meta-title {
  margin-bottom: 0 !important;
  color: #0099fa;
  font-size: 12px;
  line-height: 16px;
}

#addBook {
  /deep/ .ivu-modal-header {
    padding: 8px 16px;
  }
  /deep/ .ivu-modal-header-inner {
    font-size: 14px !important;
  }
  /deep/ .ivu-modal-close {
    top: 1px;
  }
  /deep/ .ivu-modal-body {
    height: 100px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

/deep/.ivu-page.mini .ivu-page-options {
  float: right;
  margin-right: 10px;
}

/deep/ .ivu-list-item {
  padding: 8px 0;
  cursor: pointer;
}
.active {
  border: 2px solid #0099fa;
}
.noActive {
  border: 1px solid #ece6e6;
}
.icon {
  width: 29px;
  cursor: pointer;
}
.ivu-row {
  display: block;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/bookMarkManage/bookMarkManage.vue